import NewsletterModule from '@components/NewsletterModule'

const Newsletter = (props) => <NewsletterModule {...props} />

export default Newsletter